import React from "react";
import { DsButton } from "../../ds";

export const ProductionActions = ({ item, busy, onApprove, onRetry, onReject, suffix = "" }) => {
  if (item.status === "waiting_for_video") {
    return (
      <div className="flex gap-2 mt-auto">
        <DsButton variant="go" className="flex-1" disabled={busy} onClick={onApprove} data-testid={`gallery-approve-production-${item.id}${suffix}`}>Approve for production</DsButton>
        <DsButton variant="no" className="flex-1" disabled={busy} onClick={onReject} data-testid={`gallery-reject-${item.id}${suffix}`}>Reject</DsButton>
      </div>
    );
  }
  if (item.status === "production_failed") {
    return (
      <div className="flex flex-col gap-2 mt-auto">
        <p className="text-xs text-[color:var(--bad)]" data-testid={`gallery-production-note-${item.id}${suffix}`}>
          Production failed{item.production_note ? `: ${item.production_note}` : "."}
        </p>
        <DsButton variant="go" disabled={busy} onClick={onRetry} data-testid={`gallery-retry-production-${item.id}${suffix}`}>Retry production</DsButton>
      </div>
    );
  }
  if (item.status === "production_approved" && item.production_approved_at) {
    return (
      <p className="text-xs text-[color:var(--muted)]" data-testid={`gallery-production-approved-${item.id}${suffix}`}>
        Approved for production{item.production_approved_by ? ` by ${item.production_approved_by}` : ""}
      </p>
    );
  }
  return null;
};
